var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-section-separator"},[(_vm.icon)?_c('a-icon',{attrs:{"type":_vm.icon}}):_vm._e(),_c('span',{staticClass:"font-weight-bold font-size-20"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }